module.exports = __webpack_public_path__ + "static/media/archive.a472597d.svg";